import { PalleteColor } from 'nanaykuna-ui-kit/loader';

export const DELIVERED_STATUS_LABEL = 'Validado';

export const CREATED_STATUS_LABEL = 'Creado';

export const ACCEPTED_STATUS_LABEL = 'Aceptado';

export const REJECTED_STATUS_LABEL = 'Rechazado';

export const KNOWN_STATUS_LABELS = [
  CREATED_STATUS_LABEL,
  ACCEPTED_STATUS_LABEL,
  REJECTED_STATUS_LABEL,
  DELIVERED_STATUS_LABEL,
];

export const UNMAPPED_STATUS_PLACEHOLDER = '—';

// Text color per status label. Aceptado reads blue only inside a
// `data-brand="progresol"` scope (see PROGRESOL_SCOPED_STATUS_LABELS); under
// the UNACEM brand `primary-600` is its dark red. Rechazado is brand-dependent
// on purpose: the design asks for the UNACEM red (#9F0824), which no
// brand-neutral feedback token matches (`feedback-error-dark` is #991B1B), so
// under another `data-brand` it takes that brand's primary. Creado and the
// fallback use `neutral-500`: `neutral-400` drops below WCAG AA on the striped
// and hovered table rows.
export const ORDER_STATUS_TEXT_COLOR: Record<string, PalleteColor> = {
  [CREATED_STATUS_LABEL]: 'neutral-500',
  [ACCEPTED_STATUS_LABEL]: 'primary-700',
  [REJECTED_STATUS_LABEL]: 'primary-600',
  [DELIVERED_STATUS_LABEL]: 'feedback-success-dark',
};

export const ORDER_STATUS_TEXT_COLOR_FALLBACK: PalleteColor = 'neutral-500';

export const PROGRESOL_SCOPED_STATUS_LABELS = [ACCEPTED_STATUS_LABEL];
